import { EGDSLayoutFlex, EGDSLayoutFlexItem } from '@egds/react-core/layout-flex';
import { EGDSSpacing } from '@egds/react-core/spacing';
import * as React from 'react';
import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';
import { PropertyDirectFeedbackPromptId, PropertyDirectFeedbackPromptIdSplitted } from '@shared-ui/lodging-property-details';
import { ViewLarge, Viewport, ViewSmall } from '@shared-ui/viewport-context';
import { withSharedUiPropertyDetails } from '../shared-ui/details/shared-ui-property-details';
import { usePropertyDetailsQueryCSRExperiment } from '../shared-ui/details/use-property-details-query';
const Component = ({
  inputs
}) => {
  const cSRPropertyDetailsQuery = usePropertyDetailsQueryCSRExperiment();
  return React.createElement(Experiment, {
    name: "Dated_PDP_Split_ProductDetailsQuery"
  }, React.createElement(ExperimentControl, null, React.createElement(EGDSSpacing, {
    margin: {
      blockstart: 'four',
      blockend: 'six'
    }
  }, React.createElement("div", null, React.createElement(Viewport, null, React.createElement(ViewLarge, null, React.createElement(EGDSLayoutFlex, {
    justifyContent: "center"
  }, React.createElement(PropertyDirectFeedbackPromptId, {
    inputs: inputs,
    skipSsr: cSRPropertyDetailsQuery
  }))), React.createElement(ViewSmall, null, React.createElement(EGDSLayoutFlex, {
    justifyContent: "center"
  }, React.createElement(EGDSLayoutFlexItem, null, React.createElement("div", null, React.createElement(PropertyDirectFeedbackPromptId, {
    inputs: inputs,
    skipSsr: cSRPropertyDetailsQuery
  }))))))))), React.createElement(ExperimentVariant, {
    bucket: 1
  }, React.createElement(EGDSSpacing, {
    margin: {
      blockstart: 'four',
      blockend: 'six'
    }
  }, React.createElement("div", null, React.createElement(Viewport, null, React.createElement(ViewLarge, null, React.createElement(EGDSLayoutFlex, {
    justifyContent: "center"
  }, React.createElement(PropertyDirectFeedbackPromptIdSplitted, {
    inputs: inputs,
    skipSsr: cSRPropertyDetailsQuery
  }))), React.createElement(ViewSmall, null, React.createElement(EGDSLayoutFlex, {
    justifyContent: "center"
  }, React.createElement(EGDSLayoutFlexItem, null, React.createElement("div", null, React.createElement(PropertyDirectFeedbackPromptIdSplitted, {
    inputs: inputs,
    skipSsr: cSRPropertyDetailsQuery
  }))))))))));
};
const PropertyAboutThisPropertyDirectFeedback = React.memo(({
  inputs
}) => React.createElement(Component, {
  inputs: inputs
}));
export const PropertyAboutThisPropertyDirectFeedbackWrapper = withSharedUiPropertyDetails(PropertyAboutThisPropertyDirectFeedback);
PropertyAboutThisPropertyDirectFeedbackWrapper.displayName = 'PropertyAboutThisPropertyDirectFeedbackWrapper';